import IconClose from 'asset/icon-close.svg'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { webview } from 'feature/webview/webview'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import css from './WebviewCloseButton.module.scss'

export const WebviewCloseButton = observer(() => {
  const onClick = useLatestCallback(() => {
    webview.close()
  })

  return <Space className={css.space}>
    <Button className={css.button} xl compact action={onClick}>
      <IconClose />
    </Button>
  </Space>
})
